import {RouterProps} from "../../RouterProps";
import {useStatePair} from "react-type-extension";
import {EnvFaqValueObject} from "../../../data/value-object/env/EnvFaqValueObject";
import {EnvFaqSearchOption} from "../../../data/search-option/env/EnvFaqSearchOption";
import {SortOrder} from "ts-protocol-extension";
import ListPageWrapper from "../../ListPageWrapper";
import {EnvFaqIO} from "../../../io/EnvIO";
import {EnvFaqDescription} from "../../../data/description/env/EnvFaqDescription";
import {EnvFaqDescriptor} from "../../../data/descriptor/env/EnvFaqDescriptor";
import ListOption from "../../ListOption";
import {EnvFaqSearchOptionDescription} from "../../../data/description/env/EnvFaqSearchOptionDescription";
import {
    applyEnvFaqSearchOption,
    EnvFaqSearchOptionField
} from "../../search-option-field/env/EnvFaqSearchOptionField";
import ListOrder from "../../ListOrder";
import {SearchIndex} from "../../../io/HttpClient";

enum Phase {
    List,
    Option,
    Order
}

export default function List(props: RouterProps) {
    const phase = useStatePair<Phase>(Phase.List)
    const items = useStatePair<EnvFaqValueObject[]>([])
    const option = useStatePair<EnvFaqSearchOption>({})
    const index = useStatePair<SearchIndex>({ pageIndex: 0n, sortOrder: [SortOrder.ASC], sortPriority: ['id'] })

    return <>
        {phase.value === Phase.List && <>
            <ListPageWrapper
                {...props}
                client={EnvFaqIO}
                items={items}
                option={option.value}
                index={index}
                description={EnvFaqDescription}
                descriptor={EnvFaqDescriptor}
                showPost
                onPostClick={() => document.location = '/env/faqs/post'}
                showFilter
                onFilterClick={() => phase.setter(Phase.Option)}
                showSort
                onSortClick={() => phase.setter(Phase.Order)}
                onItemClick={item => `/env/faqs/${item.id}`}/>
        </>}
        {phase.value === Phase.Option && <>
            <ListOption
                {...props}
                option={option.value}
                description={EnvFaqSearchOptionDescription}
                fields={EnvFaqSearchOptionField}
                onBackClick={() => phase.setter(Phase.List)}
                onApplyClick={(key, value) => {
                    applyEnvFaqSearchOption(key, value, option)
                    index.setter({ ...index.value, pageIndex: 0n })
                    items.setter([])
                }}
                onDismissClick={key => {
                    const next = { ...option.value }
                    next[key] = undefined
                    option.setter(next)
                    items.setter([])
                }} />
        </>}
        {phase.value === Phase.Order && <>
            <ListOrder
                {...props}
                index={index}
                description={EnvFaqDescription}
                onBackClick={() => phase.setter(Phase.List)}
                onOrderUpdated={() => items.setter([])} />
        </>}
    </>
}